import React from 'react';
import PropTypes from 'prop-types';
import Picker from 'react-datepicker';

const DatePicker = props => {
    const newProps = {...props};
    newProps.onChange = (date, e) => {
        props.onChange(e, {...props, value: date});
    };
    return (
        <Picker {...newProps} />
    );
};

DatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default DatePicker;